import { call, fork, put, SagaReturnType, select, take } from "redux-saga/effects";
import appSlice from "../../containers/App/reducer";
import { makeSelectAuthenticatedUserInfo } from "../../containers/App/selectors";
import { isInternalOffice } from "../../utils/isInternalOffice";
import slice from "./reducer";

import dictionaryContractorsApi from "../../api/apiServices/dictionary/controllers/contractors/contractors.api";
import { ContractorDataConverter } from "../../viewModels/Contractors/ContractorModel";

function* createContractorWatcher() {
  while (true) {
    const { payload }: ReturnType<typeof slice.actions.createContractor> = yield take(slice.actions.createContractor.type);
    const { success, reject }: SagaReturnType<typeof dictionaryContractorsApi.create> = yield call(
      [dictionaryContractorsApi, dictionaryContractorsApi.create],
      payload,
    );

    if (success) {
      yield put(slice.actions.createContractorSuccess(ContractorDataConverter.convertContractor(success.payload)));
      yield call(refreshLocalCompanies);
    }

    if (reject) {
      yield put(slice.actions.createContractorError());
    }
  }
}

function* updateContractorWatcher() {
  while (true) {
    const { payload }: ReturnType<typeof slice.actions.updateContractor> = yield take(slice.actions.updateContractor.type);
    const { success, reject }: SagaReturnType<typeof dictionaryContractorsApi.update> = yield call(
      [dictionaryContractorsApi, dictionaryContractorsApi.update],
      payload,
    );

    if (success) {
      yield put(slice.actions.updateContractorSuccess(ContractorDataConverter.convertContractor(success.payload)));
      yield call(refreshLocalCompanies);
    }

    if (reject) {
      yield put(slice.actions.updateContractorError());
    }
  }
}

function* refreshLocalCompanies() {
  const user: ReturnType<ReturnType<typeof makeSelectAuthenticatedUserInfo>> = yield select(makeSelectAuthenticatedUserInfo());
  if (isInternalOffice(user?.company.settings.officeType)) {
    yield put(appSlice.actions.loadRegularBitrixCompanies());
  }
}

export default function* createMessageModalSaga() {
  yield fork(createContractorWatcher);
  yield fork(updateContractorWatcher);
}
